import { useQuery } from "@tanstack/react-query";
import { getFeatureFlag } from "@/api/endpoints/featureFlags";
import { queryKeys } from "@/lib/queryClient";

export function useIsPaymentsEnabled() {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.featureFlags.byName("payments_enabled"),
    queryFn: () => getFeatureFlag("payments_enabled"),
    staleTime: 1000 * 60 * 10,
    refetchOnWindowFocus: true,
  });

  return {
    isPaymentsEnabled: data?.enabled ?? true,
    isLoading,
  };
}
